// @ts-nocheck
"use client";
import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import Navbar from "@/src/Components/Navigation/Navbar";
import MainSection from "@/src/Components/Navigation/MainSection";
import { UserContext } from "@/src/Contexts/UserContext";
import styles from "@/src/styles/home.module.css";
import { useRouter } from "next/navigation";
import OnDemandSection from "@/src/Components/Home/OnDemandSection";
import SendResultSection from "@/src/Components/Home/SendResultSection";
import AccurateResults from "@/src/Components/Home/AccurateResults";
import GetStartedSection from "@/src/Components/Home/GetStartedSection";
import Footer from "@/src/Components/Footer";
import Spinner from "@/src/Components/Spinner";

const Home = () => {
  const { user, langSwitch, setLangSwitch } = useContext(UserContext);
  const [pageScrolled, setPageScrolled] = useState(false);
  const router = useRouter();

  useLayoutEffect(() => {
    const defaultSwitchDone = localStorage.getItem("CERT_DEFAULT_SWITCH_DONE");
    if (navigator.language === "es" && defaultSwitchDone !== "true") {
      localStorage.setItem("CERT_DEFAULT_SWITCH_DONE", "true");
      router.push("/es");
    }
  });

  // Translate Page Object
  let id: any = "";
  if (typeof window !== "undefined") {
    id = localStorage.getItem("TUTORCERT_LANGUAGE");
    if ((id === "" || !id || id === "en") && langSwitch) {
      setLangSwitch(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", scrollFunc, true);

    return () => {
      window.removeEventListener("scroll", scrollFunc, true);
    };
  });

  const scrollFunc = useCallback(() => {
    if (!pageScrolled) {
      setPageScrolled(true);
    }
  }, []);

  return (
    <div className={styles.page}>
      <div
        className={id === "" || !id || id === "en" ? styles.englishPage : ""}
      >
        <Navbar logo="/images/logo.svg" id={id} />
        {langSwitch ? (
          <Spinner />
        ) : (
          <>
            <MainSection
            mobileImage="/images/placeholder-mobile.png"
              subtitle={`Unleash your potential and demonstrate your mastery with our esteemed certification. Gain industry recognition, boost your credibility, and open doors to exciting career opportunities.`}
              image="/images/placeholder.png"
              buttonText="Start Test"
              buttonColor="primary"
              buttonPath={
                user.id === "" ? "/signup?redirect_to=welcome" : "/welcome"
              }
            />
            {pageScrolled && (
              <>
                <OnDemandSection />
                <SendResultSection />
                <AccurateResults />
                <GetStartedSection />
                <Footer id={id} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
